import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createPromoterUsersReportSlice = (set, get) => ({
    promoterUsersReport: {
        loading: false,
        data: [],
    },
    marketerDashboardReport: {
        loading: false,
        data: null,
        error: null,
    },
    getPromoterUsersReport: async (searchValue) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ promoterUsersReport: { ...state.promoterUsersReport, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/crm/promoter-users/${encodeURIComponent(searchValue)}`,
                headers: { token }
            });
            set(state => ({ promoterUsersReport: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ promoterUsersReport: { ...state.promoterUsersReport, loading: false } }));
        }
    },
    getMarketerDashboardReport: async (userId, fromDate, toDate) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({
            marketerDashboardReport: {
                ...state.marketerDashboardReport,
                loading: true,
                error: null
            }
        }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                // baseURL: "https://alv-cr.bimeh.com",
                baseURL: config.apiUrls(),
                url: `/v1/crm/marketer-dashboard-report/${userId}/from-date/${fromDate}/to-date/${toDate}`,
                headers: { token }
            });
            set(state => ({
                marketerDashboardReport: {
                    loading: false,
                    data: resp.data,
                    error: null
                }
            }));
            return resp.data;
        } catch (error) {
            set(state => ({
                marketerDashboardReport: {
                    ...state.marketerDashboardReport,
                    loading: false,
                    error: error.message || 'خطا در دریافت اطلاعات'
                }
            }));
            throw error;
        }
    },
    clearMarketerDashboardReport: () => {
        set(state => ({
            marketerDashboardReport: {
                loading: false,
                data: null,
                error: null
            }
        }));
    }
});
